import {useCallback, useEffect, useState} from "react";
import useDownloadStore from "../store/downloadStore";
import {simpleDownloadFile} from "../utils/utils";
import {getFileUrl} from "../utils/consts";

const UseDownloadHelper = () => {

    const {state, actions} = useDownloadStore(state => state);
    const {queue, currentFile} = state;
    const {setCurrentFile, removeFileFromQueue} = actions;
    const [progress, setProgress] = useState(0);
    const [downloadSpeed, setDownloadSpeed] = useState(0);
    const [controller, setController] = useState(null);

    const abortDownload = useCallback(() => {
        if (controller) {
            controller.abort();
        }
    }, [controller]);

    useEffect(() => {
        // open file in othert windows to direct download
        if (queue.length === 0) {
            return;
        }

        const file = queue[0];
        console.log("Downloading file: ", file);
        if (file.storeUrl.startsWith("http")) {
            simpleDownloadFile(file.storeUrl, file.fileName);
        } else {
            simpleDownloadFile(getFileUrl(file), file.fileName);
        }
        
        removeFileFromQueue(file);

    }, [queue.length]);

    /*useEffect(() => {
        if (queue.length === 0 || currentFile) {
            return;
        }

        const newController = new AbortController(); // Crear un controlador de abortos
        setController(newController);
        const signal = newController.signal; // Obtener la señal

        const file = queue[0];
        removeFileFromQueue(file);
        setCurrentFile(file);
        setProgress(0);
        setDownloadSpeed(0);
        downloadFile(file, (file, downloadProgress, speed) => {
            setProgress(downloadProgress);
            setDownloadSpeed(speed);
        }, (error) => {
            toast.error(error);
        }, signal, () => {
        }).then(() => {
            requestAnimationFrame(() => {
                setCurrentFile(null);
                setProgress(0);
                setDownloadSpeed(0);
            });
        });
    }, [queue, currentFile]);*/


    return {queue, currentFile, progress, downloadSpeed, abortDownload};
}

export default UseDownloadHelper;
